import { normalizeContentText } from './contentNormalizer';

export interface SourceToken {
  original: string;
  normalized: string | null;
  type: 'word' | 'space' | 'punctuation';
}

export function tokenizeContent(value: string): SourceToken[] {
  const segments = value.match(/[\p{L}\p{N}]+|\s+|[^\p{L}\p{N}\s]+/gu) ?? [];
  return segments.map((original) => {
    if (/^\s+$/u.test(original)) return { original, normalized: null, type: 'space' as const };
    if (!/[\p{L}\p{N}]/u.test(original)) return { original, normalized: null, type: 'punctuation' as const };
    return { original, normalized: normalizeContentText(original), type: 'word' as const };
  });
}
